var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content w-100 h-100"},[_c('BIconLock',{staticClass:"lockicon m-4 h-50",attrs:{"scale":"3"}}),_c('h5',{staticClass:"mx-auto h-50"},[_vm._v(" You currently don't have permission to access this content ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }